// Benchmarking: the routes and the sidebar rows of `wealth.portfolio.benchmarking` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.portfolio.benchmarking',
    routes: [
        {
            frontend: 'desk',
            path: 'benchmarking',
            lazy: () => import('@/pages/desk/benchmarking/page'),
        },
        {
            frontend: 'ops',
            path: 'benchmarking',
            lazy: () => import('@/pages/ops/benchmarking/page'),
        },
        {
            frontend: 'view',
            path: 'benchmarking',
            lazy: () => import('@/pages/view/benchmarking/page'),
        },
    ],
    nav: [
        // SEP-199 — the IM's own clients against their ARC peer benchmark. Open to
        // an im-assistant, who reads the senior manager's rows.
        {
            frontend: 'desk',
            key: 'benchmarking',
            label: 'Benchmarking',
            href: '/desk/benchmarking',
            icon: 'BarChart3',
            group: 'overview',
            order: 130,
        },
        // SEP-199 — every client against their ARC peer benchmark, with the three
        // monthly uploads that feed it.
        {
            frontend: 'ops',
            key: 'benchmarking',
            label: 'Benchmarking',
            href: '/ops/benchmarking',
            icon: 'BarChart3',
            group: 'processing',
            order: 220,
        },
        {
            frontend: 'view',
            key: 'benchmarking',
            label: 'Benchmarking',
            href: '/view/benchmarking',
            icon: 'BarChart3',
            group: 'performance',
            order: 240,
        },
    ],
});
